// Browser notification permission flow — asks inside a user gesture, returns
// the resulting permission state ("granted" | "denied" | "default" | "unsupported").
import { fireMochiNotification } from "@/lib/mochiNotifications";

export async function maybeAskNotificationPermission() {
    if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
    if (Notification.permission !== "default") return Notification.permission;
    try {
        const result = await Notification.requestPermission();
        if (result === "granted") {
            fireMochiNotification("permission_granted", {}, { tag: "mochi-perm-ok" });
        }
        return result;
    } catch {
        return Notification.permission;
    }
}
